export interface MathJaxStyle {
    [selector: string]: {
        [property: string]: string
    }
};
export interface MathJaxConfig {
    chtml?,
    options?,
    style?: MathJaxStyle,
    [key: string]: any
}

declare let FilesFingerprint: any;
export default class Mathjax {
    protected get scriptPath(): string {
        return `${UX.utils.releasedAssetsPath()}public/mathjax-${FilesFingerprint.mathjax}/tex-mml-chtml.js`;
    };
    
    public config: MathJaxConfig;

    elements = {
        head: document.head,
        mathJaxSrc: document.createElement('script'),
        mathJaxStyles: document.createElement('style')
    };

    constructor(config?) {
        //Default config for all products
        this.config = {
            chtml: {
                fontURL:`${UX.utils.releasedAssetsPath()}public/mathjax-fonts-${FilesFingerprint.mathjaxFonts}`
           },
           options: {
            enableEnrichment: true,
            a11y: {
              speech: true,                      // switch on speech output
              braille: true
            },
            menuOptions: {
              settings: {
                assistiveMml: true,   // true to enable assitive MathML
                collapsible: false,   // true to enable collapsible math
                explorer: true      // true to enable the expression explorer
              }
            }
          },
          style: {
            'mjx-container mjx-math': {
                'font-size': '0.9em',
                'font-weight': 'bold',
            }
          },
          ...config 
        }

        this.init();
    }

    protected setStyles(styles: MathJaxStyle, styleElm: HTMLStyleElement) {
        styleElm.type = 'text/css';
        Object.keys(styles).forEach(selector => {
            let style = styles[selector];
            let css = '';
            Object.keys(style).forEach(property => {
                css += `${property}:${style[property]};`;
            });
            styleElm.innerHTML += `${selector}{${css}}`;
        });
    }

    init() {
        try {
            (window as any).MathJax = JSON.parse(JSON.stringify(this.config));
            const nonce = UX && UX.getRequestId ? UX.getRequestId() : null;
            if(nonce) {
                this.elements.mathJaxSrc.nonce = nonce;
            }
            this.elements.mathJaxSrc.type = 'text/javascript';
            this.elements.mathJaxSrc.async = true;
            this.elements.mathJaxSrc.src = this.scriptPath;
            this.setStyles(this.config.style, this.elements.mathJaxStyles);
            this.elements.head.appendChild(this.elements.mathJaxSrc);
            this.elements.head.appendChild(this.elements.mathJaxStyles);
        } catch (error) {
            console.error("something went wrong when importing MathJax :", error)
        }
    }
}
